import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { Performance } from 'components/player/Performance';

import type {
  AnyPlayerPerformanceQuery,
  AnyPlayerPerformanceQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

const ANY_PLAYER_PERFORMANCE_QUERY = gql`
  query AnyPlayerPerformanceQuery($slug: String!) {
    anyPlayer(slug: $slug) {
      slug
      ...Performance_anyPlayer
    }
  }
  ${Performance.fragments.anyPlayer}
` as TypedDocumentNode<
  AnyPlayerPerformanceQuery,
  AnyPlayerPerformanceQueryVariables
>;

const StyledFullWidthContainer = styled(FullWidthContainer)`
  padding-top: var(--double-unit);
`;

export const loader = queryLoader(
  ANY_PLAYER_PERFORMANCE_QUERY,
  ({ slug }: PageParams) => ({ slug })
);

const PlayersSlugPage = () => {
  const { data } = useQueryLoader<AnyPlayerPerformanceQuery>();

  if (!data) return null;

  const player = data.anyPlayer;

  return (
    <StyledFullWidthContainer>
      <Performance player={player} />
    </StyledFullWidthContainer>
  );
};

export default PlayersSlugPage;
